// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-3XmRR","row":"row-G5Gci","col":"col-3mJe_","request":"request-2RlDl","date":"date-3MCNR","status":"status-x2vQG"};